import React from "react";
import { FaUmbrellaBeach, FaSun, FaRegSmile } from "react-icons/fa";

export default function EmpHolidays() {
  const holidays = [
    { name: "Republic Day", date: "Jan 26", icon: <FaRegSmile />, color: "from-red-500 to-red-300" },
    { name: "Holi", date: "Mar 17", icon: <FaSun />, color: "from-yellow-400 to-yellow-200" },
    { name: "Diwali", date: "Nov 12", icon: <FaUmbrellaBeach />, color: "from-purple-500 to-pink-400" },
    { name: "Christmas", date: "Dec 25", icon: <FaSun />, color: "from-green-500 to-green-300" },
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Holiday List</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {holidays.map((holiday, idx) => (
          <div
            key={idx}
            className={`flex items-center space-x-4 p-5 rounded-2xl shadow-lg bg-gradient-to-r ${holiday.color} text-white transform hover:scale-105 transition-transform cursor-pointer`}
          >
            <div className="text-3xl">{holiday.icon}</div>
            <div>
              <p className="font-semibold text-lg">{holiday.name}</p>
              <p className="text-sm opacity-90">{holiday.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
